/**
 * Amber banner shown when wearable connections can't load because the user
 * is not authenticated (session expired, dev bypass, etc.).
 */
export function SignInForWearablesBanner() {
  return (
    <div
      role="status"
      style={{
        background: "#FFF6E5",
        color: "#7A4B00",
        border: "1px solid #F2D58A",
        borderRadius: 12,
        padding: "10px 12px",
        fontSize: 12.5,
        lineHeight: 1.5,
      }}
    >
      <div style={{ fontWeight: 600, marginBottom: 2 }}>
        Sign in to see your connected wearables
      </div>
      <div>
        Your session has expired or you&apos;re previewing without an account.
        Please sign in again to view and manage devices.
      </div>
    </div>
  );
}

export default SignInForWearablesBanner;
